module.exports = __webpack_public_path__ + "img/users-avatar.863ee579.svg";